<script>
    export default {
        props: {
            type: null,
            id: null,
            media: null,
        },
        data() {
            return {
                loading: false,
                mediaMutable: this.media,
            }
        },
        mounted() {
            this.initializeSortable();
        },
        watch: {
            media(media) {
                this.mediaMutable = media;
            },
        },
        methods: {
            initializeSortable() {
                new Sortable.default(this.$refs['elements'], {
                    filter: '.empty',
                    animation: 150,
                    onUpdate: (evt) => {
                        this.loading = true;
                        axios.post(Scoop.baseUrl + '/productMediaAssignment/move', {
                            id: this.id,
                            old_index: evt.oldIndex,
                            new_index: evt.newIndex,
                            type: this.type,
                        }).then((response) => {
                            this.mediaMutable = response.data;
                            this.loading = false;

                            this.$nextTick(() => {
                                this.$emit('reloaded');
                            })
                        });
                    },
                });
            },
            imageByPosition(collection, position) {
                return _.find(collection, (item) => {
                    return item.position == position;
                });
            },
            deassign(media) {
                axios.delete(Scoop.baseUrl + '/productMediaAssignment/' + media.id).then(() => {
                    this.mediaMutable = _.remove(this.mediaMutable, (m) => {
                        return m !== media;
                    });
                });
            },
            imgSrc(collection, position, format) {
                return Scoop.baseUrl + '/mediaserver/media/' + this.imageByPosition(collection, position).media_id + '?format=' + format;
            },
        },
        computed: {
            filteredMedia() {
                if (_.endsWith(this.type, 'Color')) {
                    return _.filter(this.mediaMutable, (media) => {
                        return media.product_variant_color_id == this.id;
                    });
                }

                if (_.endsWith(this.type, 'Size')) {
                    return _.filter(this.mediaMutable, (media) => {
                        return media.product_variant_size_id == this.id;
                    });
                }

                return this.mediaMutable;
            }
        }
    }
</script>

<template>
    <div class="dropArea">
        <div class="row">
            <div class="col-sm-12 p-h-xl text-center" v-if="loading">
                <i class="fa fa-cog fa-spin"></i>
            </div>
            <div class="col-sm-12" ref="elements" v-else>
                <div class="col-sm-2 p-m text-center droppable"
                     :class="{'empty': !imageByPosition(filteredMedia, position)}" :data-type="type" :data-id="id"
                     :data-position="position" v-for="position in 12">
                    <Lightbox
                            :id="'preview-' + imageByPosition(filteredMedia, position).media_id"
                            headline="Detailansicht"
                            :subheadline="'Bild ' + position"
                            large="true"
                            v-if="imageByPosition(filteredMedia, position)"
                    >
                        <div slot="open-template">
                            <img :src="imgSrc(filteredMedia, position, 'SCOOP_OS_THUMB')" class="img-thumbnail"
                                 v-if="imageByPosition(filteredMedia, position)"/>
                        </div>
                        <div slot="body">
                            <img :src="imgSrc(filteredMedia, position, 'SCOOP_OS_BIG')" class="img-container"
                                 :alt="imageByPosition(filteredMedia, position).media_id"/>
                        </div>
                    </Lightbox>
                    <div class="img-thumbnail blanc" v-else></div>
                    <div v-if="imageByPosition(filteredMedia, position)">
                        <span class="badge badge-primary">Bild {{ position }}</span>
                        <a @click="deassign(imageByPosition(filteredMedia, position))">
                            <i class="fa fa-times text-danger"></i>
                        </a>
                    </div>
                    <div v-else>
                        <span class="badge badge-primary">Bild {{ position }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
